__turbopack_context__.v({
  "actionError": "customer-reviews-module-scss-module__TpXhcq__actionError",
  "actionGuidance": "customer-reviews-module-scss-module__TpXhcq__actionGuidance",
  "actions": "customer-reviews-module-scss-module__TpXhcq__actions",
  "body": "customer-reviews-module-scss-module__TpXhcq__body",
  "byline": "customer-reviews-module-scss-module__TpXhcq__byline",
  "collapsed": "customer-reviews-module-scss-module__TpXhcq__collapsed",
  "currentUserReview": "customer-reviews-module-scss-module__TpXhcq__currentUserReview",
  "header": "customer-reviews-module-scss-module__TpXhcq__header",
  "ownerActions": "customer-reviews-module-scss-module__TpXhcq__ownerActions",
  "pendingNotice": "customer-reviews-module-scss-module__TpXhcq__pendingNotice",
  "ratingSummary": "customer-reviews-module-scss-module__TpXhcq__ratingSummary",
  "readMore": "customer-reviews-module-scss-module__TpXhcq__readMore",
  "review": "customer-reviews-module-scss-module__TpXhcq__review",
  "reviewGrid": "customer-reviews-module-scss-module__TpXhcq__reviewGrid",
  "reviewHeading": "customer-reviews-module-scss-module__TpXhcq__reviewHeading",
  "reviewStars": "customer-reviews-module-scss-module__TpXhcq__reviewStars",
  "reviewToggle": "customer-reviews-module-scss-module__TpXhcq__reviewToggle",
  "root": "customer-reviews-module-scss-module__TpXhcq__root",
  "u-animation-bounce": "customer-reviews-module-scss-module__TpXhcq__u-animation-bounce",
  "writeReview": "customer-reviews-module-scss-module__TpXhcq__writeReview",
});
